import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app';
import { env } from '../config/runtimeEnv';

const firebaseWebConfig = {
  apiKey: env.FIREBASE_API_KEY,
  authDomain: env.FIREBASE_AUTH_DOMAIN,
  projectId: env.FIREBASE_PROJECT_ID,
  storageBucket: env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.FIREBASE_MESSAGING_SENDER_ID,
  appId: env.FIREBASE_APP_ID,
  measurementId: env.FIREBASE_MEASUREMENT_ID,
};

let firebaseAppInstance: FirebaseApp | null = null;

const hasValidFirebaseConfig = (): boolean =>
  Boolean(
    firebaseWebConfig.apiKey &&
    firebaseWebConfig.authDomain &&
    firebaseWebConfig.projectId &&
    firebaseWebConfig.appId,
  );

export const getFirebaseWebConfig = () => firebaseWebConfig;

export const getPortalFirebaseApp = (): FirebaseApp | null => {
  if (firebaseAppInstance) return firebaseAppInstance;
  if (!hasValidFirebaseConfig()) return null;

  firebaseAppInstance = getApps().length > 0 ? getApp() : initializeApp(firebaseWebConfig);
  return firebaseAppInstance;
};

